module.exports = __webpack_public_path__ + "img/pc_none.cb7e19f2.png";